import React from 'react';
import Post from '../../components/Post';

function Practices(props) {
  return (
    <Post {...props} />
  )
}

export default Practices;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Practices/index.js